import axios from 'axios';

const BASE_URL = 'https://7f35e45a.cespro.com.br';

export default function useEbookReformaTributaria() {
    const enviarFormulario = async (dados) => {
        try {
            await axios.post(`${BASE_URL}/api/site/ebook-reforma-tributaria`, dados);
        } catch (erro) {
            console.error(erro);
            throw erro;
        }
    };
    return {
        enviarFormulario,
    };
}
